import filter from 'lodash/filter';
import join from 'lodash/join';

import { DEFAULT_DESCRIPTION } from '../constants/defaultVehicleDescription';
import { DashboardVehicle } from '../types/DashboardVehicle';

export const getVehicleDescription = (vehicle: DashboardVehicle): string => {
  const desc = filter([vehicle.year, vehicle.make, vehicle.model], Boolean);

  return desc.length > 1 ? join(desc, ' ') : DEFAULT_DESCRIPTION;
};
